import React, { useEffect, useState } from "react";
import Axios from "axios";
import { useHistory } from "react-router-dom";
import styles from "./ExhibitHall.module.css";

const ExhibitHall = () => {
  const history = useHistory();
  const [list, setList] = useState([]);

  useEffect(() => {
    Axios.get(
      `${global.config.requestUrl}user/getSponsorsLogosMshc2025?eventId=${localStorage.getItem("eventId")}`,
      { headers: { "auth-token": localStorage.exhibitorToken } }
    ).then((res) => {
      if (res.data.errorCode === 0) {
        setList(res.data.data.filter((i) => i.logo));
      }
    });
  }, []);

  // GROUPING
  const group = (lvl) => {
    if (lvl === 7) {
      return list.filter(
        (i) => String(i.logo_level) === "7" || !i.logo_level
      );
    }
    return list.filter((i) => String(i.logo_level) === String(lvl));
  };

  // 🎯 BOX SIZE (controls visual hierarchy)
  const getBoxClass = (lvl) => {
    switch (String(lvl)) {
      case "1": return styles.diamondBox;
      case "2": return styles.platinumBox;
      case "3": return styles.goldBox;
      case "4": return styles.bronzeBox;
      case "5": return styles.nickelBox;
      case "6": return styles.networkBox;
      case "7":
      default:
        return styles.silverBox;
    }
  };

  const renderLogos = (data, lvl) =>
    data.map((s, i) => (
      <a
        key={i}
        href={s.sponsor_link || "#"}
        target="_blank"
        rel="noreferrer"
        className={`${styles.logoWrap} ${getBoxClass(lvl)}`}
      >
        <img
          src={s.logo}
          alt={s.name || "sponsor"}
          className={styles.logo}
        />
      </a>
    ));

  return (
    <div className={styles.wrapper}>

      {/* HEADER */}
      <div className={styles.header}>
        <i
          className={`fa fa-arrow-left ${styles.backBtn}`}
          onClick={() => history.goBack()}
        />
        <div className={styles.title}>Sponsor List</div>
      </div>

      {/* TOP */}
      <div className={styles.topRow}>

        {/* DIAMOND */}
        <div className={styles.diamond}>
          <div className={styles.sectionTitle}>DIAMOND SPONSOR</div>
          <div className={styles.centerBox}>
            {renderLogos(group(1), 1)}
          </div>
        </div>

        {/* PLATINUM */}
        <div>
          <div className={styles.sectionTitle}>PLATINUM SPONSORS</div>
          <div className={styles.grid4}>
            {renderLogos(group(2), 2)}
          </div>
        </div>

      </div>

      {/* MIDDLE */}
      <div className={styles.row3}>

        <div>
          <div className={styles.sectionTitle}>NETWORK RECEPTION SPONSORS</div>
          <div className={styles.grid2}>
            {renderLogos(group(6), 6)}
          </div>
        </div>

        <div>
          <div className={styles.sectionTitle}>GOLD SPONSORS</div>
          <div className={styles.grid3}>
            {renderLogos(group(3), 3)}
          </div>
        </div>

        <div>
          <div className={styles.sectionTitle}>SILVER SPONSORS</div>
          <div className={styles.grid4}>
            {renderLogos(group(7), 7)}
          </div>
        </div>

      </div>

      {/* BOTTOM */}
      <div className={styles.bottomRow}>

        <div className={styles.bronze}>
          <div className={styles.sectionTitle}>BRONZE SPONSORS</div>
          <div className={styles.grid4}>
            {renderLogos(group(4), 4)}
          </div>
        </div>

        <div>
          <div className={styles.sectionTitle}>NICKEL SPONSORS</div>
          <div className={styles.grid2}>
            {renderLogos(group(5), 5)}
          </div>
        </div>

      </div>

    </div>
  );
};

export default ExhibitHall;
